package component.product

import androidx.compose.foundation.layout.height
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import feature.product.model.Product
import feature.product.viewModel.ProductViewModel

@Composable
fun ProductList(
    viewModel: ProductViewModel,
    onClick: (Product) -> Unit,
) {
    val products = viewModel.allProduct.collectAsState()
    LazyRow(modifier = Modifier.height(400.dp)) {
        items(count = products.value.count()) { index ->
            ProductCard(products.value[index], onClick = onClick)
        }
    }
}